import { __assign, __rest } from "tslib";
import { Table as MUTable, TableContainer as MUTableContainer, createStyles, makeStyles, } from '@material-ui/core';
import React from 'react';
import { Paper } from '../Paper/Paper';
import { TableBody } from './TableBody';
import { TableCell } from './TableCell';
import { TableHead } from './TableHead';
import { TableRow } from './TableRow';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: { backgroundColor: theme.palette.background.default },
    });
});
export var Table = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var classes = useStyles();
    return (React.createElement(Paper, null,
        React.createElement(MUTableContainer, null,
            React.createElement(MUTable, __assign({ classes: classes }, props), children))));
};
Table.Head = TableHead;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Cell = TableCell;
//# sourceMappingURL=Table.js.map